module.exports = __webpack_public_path__ + "static/media/category6.5fed4aa0.jpg";